/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Upload,
} from 'antd';
import { API_BASE_URL } from '../../environment';

const { Dragger } = Upload;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

const UploaderFile = ({
  className,
  maxSizeMB,
  onStartUpload,
  onUpload,
  uploadData,
  uploadUrl,
  render,
  multiple,
  onError,
  accept,
  label,
}) => {
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [progress, setProgress] = useState(null);

  const beforeUpload = (file) => {
    const isAllowedType = !accept || accept.split(',').includes(file.type);
    const errors = [];
    if (!isAllowedType) {
      errors.push('El archivo debe ser de un tipo permitido');
    }
    const isSmall = file.size / 1024 / 1024 < maxSizeMB;
    if (!isSmall) {
      errors.push(`El tamaño máximo del archivo debe ser ${maxSizeMB}MB`);
    }
    if (errors && errors.length && errors.length > 0) {
      if (onError) {
        onError(errors);
      } else {
        // eslint-disable-next-line no-alert
        alert(errors.join('\n'));
      }
    }
    return errors.length === 0;
  };

  const handleChangeUpload = (info) => {
    console.log('info', info);
    if (info.event?.type === 'progress') {
      setProgress(info.fileList);
    }
    if (info.file.status === 'uploading') {
      setUploading(true);
      onStartUpload();
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, () => {
        setUploaded(true);
        setUploading(false);
        if (onUpload) {
          onUpload(info.file.response);
        }
      });
    }
  };

  return (
    <Dragger
      name="file"
      listType=""
      accept={accept}
      multiple={multiple}
      className={className}
      showUploadList={false}
      data={uploadData}
      action={uploadUrl || `${API_BASE_URL}/upload`}
      beforeUpload={beforeUpload}
      onChange={(info) => handleChangeUpload(info)}
    >
      {render({
        label, uploading, uploaded, progress,
      })}
    </Dragger>
  );
};

UploaderFile.defaultProps = {
  className: '',
  label: 'Subir',
  uploadUrl: null,
  multiple: false,
  maxSizeMB: 2,
  uploadData: {},
  onStartUpload: () => { },
  onUpload: () => { },
  onError: null,
  render: null,
  accept: 'file/png, file/jpeg',
};
UploaderFile.propTypes = {
  className: PropTypes.string,
  accept: PropTypes.any,
  multiple: PropTypes.bool,
  label: PropTypes.string,
  uploadUrl: PropTypes.string,
  uploadData: PropTypes.any,
  maxSizeMB: PropTypes.number,
  onUpload: PropTypes.func,
  render: PropTypes.func,
  onStartUpload: PropTypes.func,
  onError: PropTypes.func,
};
export default UploaderFile;
